export const ru = {
    'autobudget-priority': 'Приоритет',
    banners: 'Объявления',
    'campaign-group': 'Кампания/Группа',
    cpa: 'CPA, {currency}',
    cpc: 'CPC, {currency}',
    'empty-priority': 'Не указан',
    'empty-rate': 'Не указана',
    name: 'Название',
    price: 'Цена в объявлении',
    status: 'Статус',
    'target-funnel': 'Целевая аудитория',
    type: 'Тип'
};
